import React from 'react'
import styles from './JSONBlock.scss'
import { Block } from '../Block'

// basic fallback component, handy for development
export const JSONBlock = ({ block, blockProps }) => (
  <Block block={block} blockProps={blockProps}>
    <div className={styles.JSONBlock}>
      <pre>
        {JSON.stringify(block.getData().toJS(), null, '  ')}
      </pre>
    </div>
  </Block>
)
